var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStockIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9168 3.75H10.4168C9.49636 3.75 8.75016 4.49619 8.75016 5.41667V10.4167C8.75016 11.3371 9.49636 12.0833 10.4168 12.0833H15.4168C16.3373 12.0833 17.0835 11.3371 17.0835 10.4167V5.41667C17.0835 4.49619 16.3373 3.75 15.4168 3.75H12.9168ZM12.9168 3.75V6.66667M2.0835 1.66667H2.91683C3.8373 1.66667 4.5835 2.41286 4.5835 3.33333V14.1666M6.66683 16.25C6.66683 15.0994 5.73409 14.1666 4.5835 14.1666M6.66683 16.25C6.66681 17.4005 5.73408 18.3333 4.5835 18.3333C3.4329 18.3333 2.50016 17.4006 2.50016 16.25C2.50016 15.0994 3.4329 14.1666 4.5835 14.1666M6.66683 16.25H17.0835",
    stroke: "#181C32",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockIcon);
export default __webpack_public_path__ + "static/media/stock-icon.4583adb53a7b800c36e6e52d4b0f8b02.svg";
export { ForwardRef as ReactComponent };